import { Spinner } from '#assets/ReactSvg.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { HelpText } from '#components/atoms/forms/index.ts';
import type { HostNoun } from '#dn-types/host.ts';
import type { EnrollmentState } from '../../types.ts';

type Props = {
  hostNoun: HostNoun;
  enrollSuccessful: EnrollmentState['enrollSuccessful'];
  handleDone: EnrollmentState['handleDone'];
};

export function TokenStatus({ hostNoun, enrollSuccessful, handleDone }: Props) {
  return (
    <>
      <HelpText className="mb-40 flex gap-4 align-center">
        <Spinner className="mr-4" state={enrollSuccessful ? 'success' : 'spinning'} aria-hidden={true} size={12} />
        {enrollSuccessful ? `Detected ${hostNoun} enrolled, redirecting…` : `Waiting for ${hostNoun}…`}
      </HelpText>
      <Button variant="secondary" onClick={handleDone} disabled={enrollSuccessful}>
        Done
      </Button>
    </>
  );
}
